import axios from 'axios';

export async function search(
  filters: Record<string, unknown>
): Promise<App.Configuration.Data.CustomTestData[]> {
  return axios.get(route('api.custom-tests.search', filters)).then((res) => res.data);
}
